<div [style.height.px]="height" [style.width.px]="width" class="page-placeholder">
    <div class="transparent"></div>
    @if (page) {
        <img
                [attr.src]="defaultImage"
                [lazyLoad]="page.thumbnailImage.url"
                [offset]="300"
                [scrollObservable]="scrollObservable"
                alt="Seitenvorschau"/>
    }
</div>